export default {
  ORGANIZATION_REPORT_INFO: '/api/organization/report/info',      // 组织查看俱乐部报告接口

  SOCIETY_REPORT_LIST: '/api/organization/report/list',           // 俱乐部报告中心

  SOCIETY_REPORT_LIST_DISPLAY_UPDATE: '/api/association/report/display/update',           //  用来公开或不公开报告的

  SOCIETY_REPORT_REVIEWRECORDS: '/api/association/report/reviewRecords',      // 俱乐部报告评审查询

  SOCIETY_REPORT_REVIEW: '/api/association/report/review',      // 俱乐部报告评审

  ORGANIZATION_INFO: '/api/organization/info',                    // 组织详情

  ORGANIZATION_MEMBER_LIST: '/api/organization/member/list',      // 组织成员列表

  SOCIETY_ASSOCIATION_INFO: '/api/association/info',              // 俱乐部主页

  SOCIETY_APPROVAL_LIST: '/api/association/approval/list',        // 俱乐部审批列表

  SOCIETY_APPROVAL_REJECT: '/api/association/approval/reject',    // 拒绝加入俱乐部

  SOCIETY_APPROVAL_AGREE: '/api/association/approval/agree',      // 同意加入俱乐部

  SOCIETY_ASSOCIATION_MANAGE: '/api/association/member/manage',   // 成员管理

  SOCIETY_ASSOCIATION_MEMBERLIST: '/api/association/member/list', // 俱乐部成员查询

  SOCIETY_ASSOCIATION_UPDATE: '/api/association/update',          // 俱乐部编辑

  SOCIETY_ASSOCIATION_MYLIST: '/api/association/myList',          // 我的俱乐部

  SOCIETY_ASSOCIATION_DYNAMIC: '/api/association/dynamic',        // 社区动态信息

  SOCIETY_ASSOCIATION_LIST: '/api/association/list',              // 俱乐部列表

  SOCIETY_ORGANIZATION_LIST: '/api/organization/list',            // 组织列表/api/organization/associationList

  SOCIETY_ORGANIZATION_ASSOCIATIONLIST: '/api/organization/associationList',     // 组织下学生俱乐部列表

  SOCIETY_ASSOCIATION_APPLY: '/api/association/apply',            // 认证俱乐部

  COMMON_GET_BANNERS: '/api/common/getBanners',   // 获取banner

  SOCIETY_ASSOCIATION_JOIN: '/api/association/join',              // 加入俱乐部

  SOCIETY_ASSOCIATION_QUIT: '/api/association/member/quit',          // 退出俱乐部

  SOCIETY_LEADER_CHANGE: '/api/association/member/leader/change',          // 转让主席

  SOCIETY_IDENTITY_REMOVE: '/api/association/member/identity/remove',          // 移除身份

  SOCIETY_IDENTITY_SETTING: '/api/association/member/identity/setting',          // 设置身份

  SOCIETY_IDENTITY_MEMBER_REMOVE: '/api/association/member/remove'          // 删除成员
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/society.js